import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import cookie from 'react-cookies';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import Toast from '../../../component/toast';
import API from '../../../server/index';
import YInput from './YInput';
import AliAwsc from "../AliAwsc/aliAwsc";

interface ModalProps {
  visible: boolean;
  close: (isLogin?: boolean) => void;
}

interface GraphCodeParams {
  graphCode?: string;
  clewNo?: string;
}

interface FormValParams {
  mobile?: string;
  graphCode?: string;
  smsCode?: string;
}

interface LoadingParams {
  getGraphCode?: boolean;
  setSms?: boolean;
  login?: boolean;
}

const Modal = observer((props: ModalProps) => {
  const { visible, close } = props;
  const timer = useRef<any>();
  const loadingRef = useRef<LoadingParams>({});
  const [formVal, setFormVal] = useState<FormValParams>({});
  const [smsCountdown, setSmsCountdown] = useState<number>(0);
  //
  const fetchRef = useRef<any>({});

  const checkFn = (checkMore = false) => {
    const { mobile = '', smsCode = '' } = formVal;
    if (!mobile?.trim()?.length ) {
      Toast('请输入手机号');
      return true;
    }
    if (checkMore && !smsCode?.trim()?.length) {
      Toast('请输入短信校验码');
      return true;
    }
    return false;
  }
 
  // 表单内容修改
  const setForm = (name: string, val: string) => {
    const params = Object.assign({}, formVal, {[name]: val})
    setFormVal(params)
    fetchRef.current.forms = params;
  }
  // 获取短信验证码
  const setSms = async (values: any) => {
    const { mobile = '' } = fetchRef.current.forms;
    if (!mobile?.trim()?.length) {
      fetchRef.current.sliderReset?.();
      Toast('请输入手机号');
      return;
    }
    loadingRef.current.setSms = true;
    try {
      await API.ApiEmployeeSmsSend28735({
        mobile: mobile.trim(),
        ...values
      });
      loadingRef.current.setSms = false;
      setSmsCountdown(60);
      startCountdown(60);
    } catch (error) {
      loadingRef.current.setSms = false;
      fetchRef.current.sliderReset?.();

    }
  }
  // 短信倒计时
  const startCountdown = (countdown: number) => {
    timer.current = setTimeout(() => {
      const next = countdown - 1;
      setSmsCountdown(next);
      if (next > 0) {
        startCountdown(next);
      } else {
        fetchRef.current.sliderReset?.();
      }
    }, 1000)
  }
  // 登录
  const login = async () => {
    const { smsCode = '', mobile = '' } = formVal;
    if (loadingRef.current.login || checkFn(true)) {
      return;
    }
    loadingRef.current.login = true;
    try {
      const res = await API.ApiEmployeeSmsLogin28742({
        mobile: mobile.trim(),
        smsCode: smsCode.trim(),
      });
      loadingRef.current.login = false;
      sessionStorage.setItem('tmpToken', res?.data?.tmpToken || '')
      // cookie.save('tmpToken', res?.data?.tmpToken || '', { expires: new Date(moment().add(1, 'day').startOf('day').valueOf()) })
      close(true)
    } catch (error) {
      loadingRef.current.login = false;
      if (error?.code === '20115') { // token
        
      }
    }

  }
  useEffect(() => {
    if (visible) {
    } else {
      clearTimeout(timer.current);
      setFormVal({});
      setSmsCountdown(0);
      fetchRef.current.sliderReset?.();
      fetchRef.current.forms  = {};

    }
    return () => {
      clearTimeout(timer.current);
    }
    // eslint-disable-next-line
  }, [visible])
  
  const sliderSuccess = (values: any) => {
    const parms = { scene: 'nc_message', ...(values ?? {}) };
    console.log(parms);
    setSms(parms);
  }
  return (
    <Container className={visible ? '' : 'close'}>
      <div className="title-wrap">
        手机校验
        <CloseOutlined onClick={() => close()} />
      </div>
      <div className="form-wrap">
        <YInput title="手机号" value={formVal.mobile} maxLength={11} onChange={(val) => setForm('mobile', val)} />
        <div className="aliview" >
        <AliAwsc width={380} awscId='smsSlider' success={sliderSuccess} reset={(reset: any) => {
            fetchRef.current.sliderReset = reset;
          }}
            upLang={{
              cn: {
                SLIDE: '按住滑块，拖至最右端发送验证短信'
              }
            }}
          />
        </div>
        <YInput
          title="短信验证码"
          value={formVal.smsCode}
          maxLength={6}
          render={(
            <div className={["sent-message", 'gray' ].join(' ')} >
              {smsCountdown ? `${smsCountdown}s后重新获取` : '获取短信验证码'}
            </div>
          )}
          onChange={(val) => setForm('smsCode', val)}
        />
        <div className="button" onClick={login}>确 认</div>
      </div>
      <div className="fixed-wrap"></div>
    </Container>
  )
})

export default Modal;

const Container = styled.div`
  width: 460px;
  position: fixed;
  top: 128px;
  left: 50%;
  margin-left: -230px;
  .title-wrap {
    height: 76px;
    background: #FFFFFF;
    box-shadow: -10px 9px 21px 0px rgba(128, 152, 213, 0.07);
    border-radius: 8px 8px 0px 0px;
    font-size: 22px;
    font-weight: bold;
    color: #0A0A0A;
    line-height: 76px;
    padding: 0 30px 0 40px;

    & > span {
      float: right;
      margin: 27px 0;
    }
  }
  .form-wrap {
    background: rgba(255,255,255,0.96);
    padding: 16px 40px 40px;
    border-radius: 0px 0px 8px 8px;

    .button {
      margin-top: 46px;
      background: #1968FC;
      border-radius: 5px;
      height: 46px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 46px;
      text-align: center;
      cursor: pointer;
    }
  }

  .fixed-wrap {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
  }

  &.close{
    display: none;
  }

  .aliview {
    margin-top: 28px;
  }
`
